import * as Yup from "yup";

import {
  CreateUserRole,
  CreateUserRoleVariables,
} from "_graphql/queries/kek/__generated__/CreateUserRole";
import { Modal, OfficeButton } from "components";

import CreateUserRoleForm from "components/forms/create-user-role";
import { createUserRole } from "_graphql/kek/queries/roles.kek";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useMutation } from "@apollo/client";
import { wrapClick } from "utils";

export const revalidationSchema = Yup.object().shape({
  position: Yup.string().required("Position is required"),
  privileges: Yup.array().min(1).required("At least one privilege is required"),
});

export interface CreateUserRoleContainerProps {
  position: string;
  privileges: string[];
}
export default function CreateUserRoleContainer({
  open,
  setOpen,
  refetch,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const [create, { loading }] = useMutation<
    CreateUserRole,
    CreateUserRoleVariables
  >(createUserRole, {
    refetchQueries: ["User_roles"],
  });

  const form = useFormik<CreateUserRoleContainerProps>({
    initialValues: {
      position: "",
      privileges: [],
    },
    validationSchema: revalidationSchema,
    onSubmit: async (values) => {
      await create({
        variables: {
          position: values.position,
          privileges: btoa(JSON.stringify(values.privileges)),
        },
      }).then(({ data }) => {
        if (data?.createUserRole) {
          toast.success("User Role Created Successfully");
          refetch?.();
          form.resetForm();
        } else {
          toast.error("Failed to create User Role");
        }
      });
    },
    onReset: () => {
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Add New User Role"
      description="Provide the details to add a new user role"
      renderActions={() => (
        <>
          <OfficeButton
            disabled={loading}
            onClick={wrapClick(form.handleSubmit)}
          >
            {loading ? "Adding User Role..." : "Add User Role"}
          </OfficeButton>
        </>
      )}
    >
      <CreateUserRoleForm form={form} />
    </Modal>
  );
}
